import React, { useEffect, useState } from 'react';
import { fetchClasses, fetchWhatsAppLinks, saveWhatsAppLink } from './attendanceApi';

const ORDER = ['Nursery', 'LKG', 'UKG', 'HKG', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
const LINK_RE = /^https:\/\/chat\.whatsapp\.com\/[A-Za-z0-9_-]{10,}\/?(\?.*)?$/;

// Principal-only: paste / update / remove the WhatsApp group invite link for every class.
export default function PrincipalWhatsAppSettings({ user, onClose }) {
  const [classes, setClasses] = useState(ORDER);
  const [links, setLinks] = useState({});   // saved values
  const [draft, setDraft] = useState({});   // edited values
  const [busy, setBusy] = useState('');
  const [msg, setMsg] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const [found, rows] = await Promise.all([fetchClasses(user), fetchWhatsAppLinks(user)]);
        setClasses([...new Set([...ORDER, ...found])]);
        const map = {};
        rows.forEach((r) => { map[r.className] = r.groupLink || ''; });
        setLinks(map);
        setDraft(map);
      } catch (e) {
        setMsg(e.response?.data?.error || 'Could not load links');
      }
    })();
  }, [user]);

  const save = async (cls, value) => {
    const v = (value || '').trim();
    if (v && !LINK_RE.test(v)) { setMsg(`Class ${cls}: not a valid chat.whatsapp.com invite link`); return; }
    setBusy(cls); setMsg('');
    try {
      await saveWhatsAppLink(user, cls, v);
      setLinks((p) => ({ ...p, [cls]: v }));
      setDraft((p) => ({ ...p, [cls]: v }));
      setMsg(v ? `Class ${cls}: link saved` : `Class ${cls}: link removed`);
    } catch (e) {
      setMsg(e.response?.data?.error || 'Save failed');
    } finally { setBusy(''); }
  };

  if (user.role !== 'principal') return null;

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 12 }}>
      <div style={{ background: '#fff', borderRadius: 14, width: '100%', maxWidth: 680, maxHeight: '92vh', display: 'flex', flexDirection: 'column' }}>
        <div style={{ padding: '14px 18px', borderBottom: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ margin: 0, color: '#15803d' }}>💬 WhatsApp Group Links</h3>
          <button onClick={onClose} style={{ border: 'none', background: 'none', fontSize: 22, cursor: 'pointer' }}>✕</button>
        </div>
        {msg && <div style={{ padding: '8px 18px', background: '#f0fdf4', color: '#166534', fontSize: 13 }}>{msg}</div>}
        <div style={{ overflowY: 'auto', padding: 14 }}>
          {classes.map((cls) => {
            const changed = (draft[cls] || '') !== (links[cls] || '');
            return (
              <div key={cls} style={{ display: 'flex', gap: 6, alignItems: 'center', marginBottom: 8 }}>
                <b style={{ width: 70, fontSize: 13 }}>{/^\d+$/.test(cls) ? `Class ${cls}` : cls}</b>
                <input
                  value={draft[cls] || ''}
                  placeholder="https://chat.whatsapp.com/..."
                  onChange={(e) => setDraft((p) => ({ ...p, [cls]: e.target.value }))}
                  style={{ flex: 1, minWidth: 0, padding: '8px 10px', border: '1.5px solid #d1d5db', borderRadius: 8, fontSize: 13 }}
                />
                <button disabled={!changed || busy === cls} onClick={() => save(cls, draft[cls])}
                  style={{ padding: '8px 12px', border: 'none', borderRadius: 8, background: changed ? '#16a34a' : '#d1d5db', color: '#fff', fontWeight: 700, cursor: changed ? 'pointer' : 'default' }}>
                  Save
                </button>
                {links[cls] && (
                  <button disabled={busy === cls} onClick={() => save(cls, '')} title="Remove link"
                    style={{ padding: '8px 10px', border: 'none', borderRadius: 8, background: '#fee2e2', color: '#b91c1c', cursor: 'pointer' }}>🗑</button>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
